import { LinearProgress } from '@mui/material';
import { useProgramStatusBar } from '../../../hooks/ui/useProgramStatusBar';
import { useSmoothedDeployProgress } from '../../../hooks/ui/useSmoothedDeployProgress';

const ProgramStatusBar = () => {
  const { mode, progress, ariaLabel } = useProgramStatusBar();
  const smoothedDeployProgress = useSmoothedDeployProgress(mode === 'deploying' ? progress : null);

  if (!mode) {
    return null;
  }

  const variant = mode === 'deploying' ? 'determinate' : 'indeterminate';
  const value = mode === 'deploying' ? Math.min(100, Math.max(0, smoothedDeployProgress ?? 0)) : undefined;

  return (
    <LinearProgress
      variant={variant}
      value={value}
      aria-label={ariaLabel}
      sx={(theme) => ({
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 4,
        borderRadius: 0,
        backgroundColor: theme.vars?.palette?.action?.hover ?? theme.palette.action.hover,
        '& .MuiLinearProgress-bar': {
          backgroundColor:
            mode === 'deploying'
              ? theme.vars?.palette?.chart?.blue ?? theme.palette.chart.blue
              : theme.vars?.palette?.chart?.green ?? theme.palette.chart.green,
        },
      })}
    />
  );
};

export default ProgramStatusBar;
